var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-menu"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu",
    clipPath: "url(#clip-menu)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4379",
    "data-name": "Group 4379",
    transform: "translate(-45.422 -49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(45.421 50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M68.221,69.556h-21.6a1.222,1.222,0,0,0,0,2.444h21.6a1.222,1.222,0,0,0,0-2.444Zm-21.6-17.112h21.6a1.222,1.222,0,0,0,0-2.444h-21.6a1.222,1.222,0,0,0,0,2.444Zm21.6,7.334h-21.6a1.222,1.222,0,0,0,0,2.444h21.6a1.222,1.222,0,0,0,0-2.444Z",
    transform: "translate(-45.421 -50)",
    fill: "#34495e"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.00942782ffd53374eb6737bf02ae4fd7.svg";
export { ForwardRef as ReactComponent };